import React from "react";
import PropTypes from "prop-types";
import { Typography, Form, Row, Col, Input, Radio } from "antd";
import { useTranslation } from "react-i18next";
import { PhoneInput } from "ui/Input";

const { Text } = Typography;
const { TextArea } = Input;

const ContactInformationBlock = ({ form, setPhoneNumber, phoneNumber }) => {
    const [t] = useTranslation()
    const accessRequirement = Form.useWatch("user_input", form);

    return (
        <>
            <Text style={{ fontSize: "18px", fontWeight: 600 }}>{t("webIntegration.contact_information")}</Text>
            <Row gutter={[16, 16]} style={{ marginTop: "24px" }}
            >
                <Col span={24}>
                    <Form.Item
                        name="firstName"
                        label="First Name"
                        rules={[{ required: true, message: "Please enter your first name" }]}
                    >
                        <Input placeholder="First Name" />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name="lastName"
                        label="Last Name"
                        rules={[{ required: true, message: "Please enter your last name" }]}
                    >
                        <Input placeholder="Last Name" />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                            { required: true, message: "Please enter your email" },
                            { type: "email", message: "Enter a valid email" },
                        ]}
                    >
                        <Input placeholder="Email" />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name="phone_number"
                        label="Phone Number"
                        rules={[{ required: true, message: "Please enter your phone number" }]}
                    >
                        <PhoneInput initialValue={phoneNumber} onChange={(val) => {
                            if (val) {
                                setPhoneNumber(val)
                            }
                        }} />
                    </Form.Item>
                </Col>
            </Row>
            <div style={{ marginTop: "32px" }}>
                <Text>
                    {t("webIntegration.party_access_required")}
                </Text>
            </div>
            <Form.Item name="user_input" style={{ marginTop: "20px" }}>
                <Radio.Group
                    options={[
                        { value: 1, label: "Yes" },
                        { value: 2, label: "No" },
                    ]}
                />
            </Form.Item>
            {accessRequirement === 1 && (
                <Form.Item
                    name="access_detail"
                    label="Notes"
                    rules={[{ required: true, message: "Please provide details" }]}
                >
                    <TextArea rows={4} placeholder="Describe access requirements..." />
                </Form.Item>
            )}
        </>
    );
};

export default ContactInformationBlock;

ContactInformationBlock.propTypes = {
    form: PropTypes.object,
    phoneNumber: PropTypes.number,
    setPhoneNumber: PropTypes.func
};
